
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
    OrderRecordService,
    OrderRecordRegistrationDto,
} from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import { __param } from "tslib";
import UserRegistration from "./components/user-registration.vue";
class OrderRecordRegistrationInput extends PagedRequestDto {
    schoolName: string;
}
@Component({
    name: "UnicomRegistration",
    components: {
        Pagination,UserRegistration,
    },
})
export default class UnicomRegistration extends PagedListBase<
    OrderRecordRegistrationInput,
    OrderRecordRegistrationDto
> {
    request = new OrderRecordRegistrationInput();
    private orderRecordService = new OrderRecordService();

    private editDialogVisible = false;
    private isLoading = false;
    allRegistrationCount = 0;
    allDealCount = 0;
    allUnsubscribeCount = 0;

    isTableLoading = false;
    isTableLoadingTable = false;
    activeName = "first"; //tab值
    getpage(): void {
        
        var type = this.$route.params["navType"];
        if(type=='second'){
            this.activeName=type
        }
        this.getOrderRecordRegistration();
    }
    created() {
        this.refresh();
    }
    // tab切换
    handleClick(tab, event) {

    }
    //点击查询按钮
    search() {
        this.currentPage = 0;
        this.request.skipCount = 0;
        this.getOrderRecordRegistration();
    }
    //获取列表
    getOrderRecordRegistration() {
        this.isTableLoading = true;
        console.log(this.request);
        this.orderRecordService
            .getOrderRecordRegistration(
                this.request.schoolName,
                this.request.sorting,
                this.request.skipCount,
                this.request.maxResultCount
            )
            .then((result) => {
                console.log(result);
                this.list = result.items;
                this.allDealCount = result.allDealCount;
                this.allRegistrationCount = result.allRegistrationCount;
                this.allUnsubscribeCount = result.allUnsubscribeCount;
                this.showPaging(result);
            })
            .finally(() => {
                this.isTableLoading = false;
            });
    }

    //点击行
    handleSelectionChange(val) {
        // console.log("sdfasdasdf22+:"+val.id)
        // this.viewDetail(val.id)
    }
    //查看详情
    viewDetail(id) {
        this.$router.push({
            name: "recordSchool",
            params: { id: id },
        });
    }

    //设置广告点击
    advertisingSettings(id, schoolName) {
        this.$router.push({
            name: "advertisingSpace",
            params: { id: id, schoolName: schoolName },
        });
    }
}
